import { render, staticRenderFns } from "./AddPricelistMemberDlg.vue?vue&type=template&id=0d13583e&"
import script from "./AddPricelistMemberDlg.vue?vue&type=script&lang=js&"
export * from "./AddPricelistMemberDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddPricelistMemberDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports